import { Proposal } from '@/models/proposal.model';
import { ProposalConsignado } from '@/models/proposalConsignado.model';
import { create } from 'zustand';

interface ProposalState {
  proposal: Proposal | ProposalConsignado | null;
  setProposal: (proposal: Proposal | ProposalConsignado) => void;
  clearProposal: () => void;
}

export const useProposalStore = create<ProposalState>((set) => ({
  proposal: null,
  setProposal: (proposal :Proposal | ProposalConsignado) => set({ proposal }),
  clearProposal: () => set({ proposal: null }),
}));
